import { fork, put, takeLatest } from 'redux-saga/effects';
import { putAndWaitHandleAllAPIError } from '../../../api/API.sagas';
import {
    API_GET_CUSTOMER_STATE,
    API_GET_APPLICATION,
    API_GET_ACCOUNTS,
    API_GET_ONLINE_ACCOUNT,
    API_GET_PRODUCT_OFFERS,
    API_GET_FORMAL_OFFERS
} from '../../../api/lendingAPI/LendingAPI.actions';
import { createWorkersForPage } from '../../pageStructure/routerWorkers/PageWorkerFactory.sagas';
import {
    ACTIVATE_RBL_DASHBOARD,
    DASHBOARD_READY,
    OUTSTANDING_DASHBOARD_READY
} from './Dashboard.actions';
import {
    APPROVED_STATUS,
    OUTSTANDING_STATUS,
    getRBLAccount,
    getRBLApplication,
    OFFERED_APPLICATION_STATUS,
    getRBLApplicationStatus,
    hasAccountPagesApplication,
    getRBLFormalOffer,
    getRBLFormalOfferStatus,
    PENDING_STATUS,
    UNKNOWN_STATUS
} from './Dashboard.helpers';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';

export const RBL_URL = '/revenue-based-loan/';
export const RBLDashboardSagaWorkers = createWorkersForPage({
    page: 'RBL_DASHBOARD',
    isInPageLocation: (location) => location.pathname === RBL_URL,
    createPageFlowWorkers: () => [fork(RBLdashboardPageWorker)]
});

// TODO: figure out a way to call API_GET_PRODUCT_OFFERS only when status is APPLY_REVENUE_BASED_LOAN_STATUS

//If customer has a valid account with no active formal offer, direct them to the account dashboard (outstanding)
//or If customer has an application that is not offered take show the application status
///or If customer has a formal offer, show the formal offer status
function* RBLdashboardPageWorker() {
    yield takeLatest(ACTIVATE_RBL_DASHBOARD, function* () {
        const [
            accountsResponse,
            applicationResponse,
            customerStateResponse,
            formalOffersResponse
        ] = yield putAndWaitHandleAllAPIError([
            { type: API_GET_ACCOUNTS },
            { type: API_GET_APPLICATION },
            { type: API_GET_CUSTOMER_STATE },
            { type: API_GET_FORMAL_OFFERS },
            { type: API_GET_PRODUCT_OFFERS }
        ]);

        const rblAccount = getRBLAccount(accountsResponse.response);
        const rblFormalOffer = getRBLFormalOffer(formalOffersResponse.response);
        const rblApplication = getRBLApplication(applicationResponse.response);
        const accountPagesApplication = hasAccountPagesApplication(
            customerStateResponse.response
        );

        if (accountPagesApplication) {
            return yield put({
                type: REQUEST_CHANGE_ROUTER,
                location: { pathname: '/apply-flexi-loan/' }
            });
        }

        if (rblAccount) {
            //check for repeat customer's formal offer
            const hasRepeatApproval =
                rblFormalOffer &&
                getRBLFormalOfferStatus(rblFormalOffer) === APPROVED_STATUS &&
                rblAccount.loan_status === 'ended';

            if (!hasRepeatApproval) {
                yield putAndWaitHandleAllAPIError([
                    { type: API_GET_ONLINE_ACCOUNT }
                ]);
                yield put({ type: OUTSTANDING_DASHBOARD_READY });
                return yield put({
                    type: DASHBOARD_READY,
                    status: OUTSTANDING_STATUS
                });
            }
        }

        if (rblApplication) {
            const applicationStatus = getRBLApplicationStatus(rblApplication);
            if (applicationStatus !== OFFERED_APPLICATION_STATUS) {
                return yield put({
                    type: DASHBOARD_READY,
                    status: applicationStatus
                });
            } else if (
                applicationStatus === PENDING_STATUS &&
                accountPagesApplication
            ) {
                return yield put({
                    type: REQUEST_CHANGE_ROUTER,
                    location: { pathname: '/apply-flexi-loan/' }
                });
            }
        }

        if (rblFormalOffer) {
            const formalOfferStatus = getRBLFormalOfferStatus(rblFormalOffer);
            if (formalOfferStatus === APPROVED_STATUS) {
                return yield put({
                    type: REQUEST_CHANGE_ROUTER,
                    location: { pathname: '/my-offers/' }
                });
            } else
                return yield put({
                    type: DASHBOARD_READY,
                    status: formalOfferStatus
                });
        } else {
            return yield put({
                type: DASHBOARD_READY,
                status: UNKNOWN_STATUS
            });
        }
    });
}
